export default "<app-login-mfa></app-login-mfa>\r\n";